export class ProjectSaleQuotationInfo {
  ProjectSaleQuotationID: number
  ProjectSaleID: number
  ProjectSaleCode: string
  ProjectSaleName: string
  ProjectSaleQuotationType: string
  ProjectSaleQuotationNo: string
  ProjectSaleQuotationPrice: number
  ProjectSaleQuotationBacklogFlag: string
  ProjectSaleQuotationActiveFlag: string
  ProjectSaleQuotationIsUseFlag: string
  ProjectSaleQuotationCreateDate: string
  ProjectSaleQuotationCreateBy: string
  ProjectSaleQuotationUpdateDate: string
  ProjectSaleQuotationUpdateBy: string
  ProjectSaleQuotationFlagDelete: string
  ProjectSaleQuotationAttachmentAmount: number
}
